import { DEFAULT_THEME_TOKENS } from './tokens';
import { createAppTheme } from './createAppTheme';

export type { BrandingConfig, ThemeShape, ThemeTokens } from './tokens';
export {
    BRANDING_STORAGE_KEY,
    DEFAULT_BRANDING,
    DEFAULT_THEME_TOKENS,
    THEME_PRESETS,
    getShapeRadii,
} from './tokens';
export {
    applyThemeTokens,
    hydrateThemeFromStorage,
    loadBrandingConfig,
    saveBrandingConfig,
    resetBrandingConfig,
} from './applyTheme';
export { createAppTheme } from './createAppTheme';
export { mixColors, withAlpha, isValidHexColor } from './colorUtils';
export { AppThemeProvider, useAppTheme, useBrandLogo } from './ThemeContext';
export { buildReactSelectTheme } from './reactSelectTheme';

/** Static default theme — prefer AppThemeProvider for runtime branding. */
export const theme = createAppTheme(DEFAULT_THEME_TOKENS);
